// Module
var code = `<ng-form name="\$ctrl.automaticTransferForm">
  <h2 class="section-header">Automatic Transfer</h2>
    <table class="table">
      <tbody class="tbody">
        <tr>
          <td class="label">Account:</td>
          <td class="values">
            <selectize
                    name="ataAccount"
                    options="\$ctrl.accounts"
                    ng-model="\$ctrl.automaticTransfer.accountId"
                    config="\$ctrl.accountSelectConfig"
                    ng-required="\$ctrl.automaticTransfer.transferStrategy != 'NONE'"
                    class="nx-selectize"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
            >
            </selectize>
          </td>
        </tr>
        <tr>
          <td class="label">
            Transfer strategy:
          </td>
          <td class="values">
            <select
                title="Value of None disables all payments. Pay as much as possible means
that if account has insufficient balance to pay full amortization, payment will still be performed.
Always pay full amortizations will perform payment only if account balance is sufficient to pay full amount of amortizations."
                ng-model="\$ctrl.automaticTransfer.transferStrategy"
                ng-options="strategy.value as strategy.label for strategy in \$ctrl.transferStrategies"
                ng-disabled="!\$ctrl.isEditModeEnabled()">
            </select>
          </td>
        </tr>
      </tbody>
    </table>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/loan-automatic-transfer/loan-automatic-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;